import {type ParserT, number, string, record, nullable} from '@freckle/parser'
import {type RlDomainIdT} from '@frontrow/console/src/entities/types/rl-domain-id'
import * as RlDomainId from '@frontrow/console/src/entities/types/rl-domain-id'

import {type RlDomainT, parseDomainAttrs} from '@frontrow/console/src/entities/models/rl-domain'
import {type RlStandardIdT} from '@frontrow/console/src/entities/types/rl-standard-id'
import * as RlStandardId from '@frontrow/console/src/entities/types/rl-standard-id'

export type RlStandardT = {
  id: RlStandardIdT
  name: string // Standard "Code," e.g. "K.CC.1";
  shortName: string // "Name" for the standard, e.g. "Count to 100";
  description: string // Longer form, e.g. "Count to 100 by ones and by tens.";
  progressionOrder: number
  grade: number
  domainId: RlDomainIdT
  // TODO: remove this nullable type and use RlStandardWithDomainT when appropriate
  // https://app.asana.com/0/149473556304568/1200915504043803/f
  domain?: RlDomainT | null
}

export const parseStandardAttrs: ParserT<RlStandardT> = record({
  id: RlStandardId.parse,
  name: string(),
  shortName: string(),
  description: string(),
  progressionOrder: number(),
  grade: number(),
  domainId: RlDomainId.parse,
  domain: nullable(parseDomainAttrs)
})
